import { z } from 'zod';

/**
 * `GET /health` (API_DOCS.md — unauthenticated liveness probe).
 *
 * `exchange` is `null` until an IExchangeGateway exists (Phase 2); `ok` reflects only the
 * dependencies the process genuinely needs to serve requests right now.
 */
export const healthResponseSchema = z.object({
  ok: z.boolean(),
  db: z.boolean(),
  exchange: z.boolean().nullable(),
  uptimeSec: z.number().int().nonnegative(),
  version: z.string(),
});
export type HealthResponse = z.infer<typeof healthResponseSchema>;
